/**
 * @desc 全局组件注册
 */
import Vue from 'vue'
import './components/toast/'
import './components/spinner/'
import prompt from './components/Prompt'
import errorPanel from './components/Error'

Vue.component('prompt', prompt)
Vue.component('errorPanel', errorPanel)
